import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import ProgressBar from "../../../utils/progressBar/ProgressBar";
import { useDispatch, useSelector } from "react-redux";
import SalesForm from "./SalesForm";
import Pagination from "../../../utils/pagination/Pagination";
import "./SalesOrder.css";
import { Trash2, SquarePen, Eye, Plus } from "lucide-react";
import { getSalesOrders } from "../../../redux/reduxApi/salesOrdersReduxApi";
import { countSalesOrders } from "../../../redux/api/salesOrdersApi/salesOrdersApi";
import { deleteSalesOrders } from "../../../redux/api/salesOrdersApi/salesOrdersApi";
import { deletesalesOrdersAction } from "../../../redux/reduxSlice/SalesOrdersSlice";
import { getCompany } from "../../../redux/reduxApi/companyReduxApi.js";
import { getEmployees } from "../../../redux/reduxApi/employeeReduxApi.js";
import { useNavigate } from "react-router-dom";
import { getVendor } from "../../../redux/reduxApi/vendorReduxApi";
import { Table, Thead, Tbody, Tr, Th, Td, TableContainer, Checkbox, Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter, ModalBody, Button, Spinner, ModalCloseButton } from "@chakra-ui/react";
import EllipsisMenu from "../../../utils/EllipsisDropdown/EllipsisMenu.js";
function SalesList(sidebarColor) {
  const desktopRef = useRef(null);
  const navigate = useNavigate();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(5);
  const [isOpen, setIsOpen] = useState(false);
  const dispatch = useDispatch();
  const salesOrdersData = useSelector((state) => state?.salesOrders?.salesOrders);
  const [loading, setLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [deleteSalesOrdersROWID, setDeleteSalesOrdersROWID] = useState("");
  const [showProgressBar, setShowProgressBar] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [isUpdateMode, setIsUpdateMode] = useState(false);
  const [dataToEdit, setDataToEdit] = useState({});
  const [salesOrdersROWId, setSalesOrdersROWId] = useState("");
  const [salesOrdersId, setSalesOrdersId] = useState("");
  const [company, setCompanies] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [vendor, setVendor] = useState([]);
  const companyData = useSelector((state) => state.utils.companyList);
  const userList = useSelector((state) => state.utils.userList);
  const vendorData = useSelector((state) => state.utils.vendorList);
  //to show add & delete button according to permissions
  const permissions = localStorage.getItem("permissions");
  const filterData = JSON.parse(permissions);
  const showAddBtn = filterData[1].add;
  const showDeleteBtn = filterData[1].delete;
  console.log("filetr data", filterData); // getVendor
  useEffect(() => {
    dispatch(getVendor())
      .catch((error) => {
        console.error("Error fetching getVendor data:", error);
      })
      .finally(() => {});
  }, []);

  // getEmployess
  useEffect(() => {
    dispatch(getEmployees())
      .catch((error) => {
        console.error("Error fetching getEmployees data:", error);
      })
      .finally(() => {});
  }, []);

  // getCompany
  useEffect(() => {
    dispatch(getCompany())
      .catch((error) => {
        console.error("Error fetching getCompany data:", error);
      })
      .finally(() => {});
  }, []);

  // get salesOrders
  useEffect(() => {
    setLoading(true);
    dispatch(getSalesOrders({ page: currentPage, limit: 30, size: 30 }))
      .catch((error) => {
        console.error("Error fetching salesOrders data:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [currentPage, dispatch]);

  const fetchTotalCount = async () => {
    try {
      const response = await countSalesOrders();
      console.log("API Response:", response.data);
      const count = parseInt(response.data.count, 10);
      setTotalCount(count);
    } catch (error) {
      console.error("Error fetching total salesOrders count:", error);
    }
  };

  const handleNewData = () => {
    fetchTotalCount();
  };

  useEffect(() => {
    fetchTotalCount();
  }, []);

  const handleDelete = () => {
    setShowProgressBar(true);
    setLoading(true);
    const idsToDelete = selectedRows.length === 0 ? [deleteSalesOrdersROWID] : selectedRows;
    Promise.all(idsToDelete.map((id) => deleteSalesOrders(id)))
      .then(() => {
        setSelectedRows([]);
        dispatch(deletesalesOrdersAction(idsToDelete));
        toast.success("Row deleted successfully");
        fetchTotalCount();
      })
      .catch(() => {
        toast.error("Row not deleted");
      })
      .finally(() => {
        setIsOpen(false);
        setDeleteSalesOrdersROWID("");
        setShowProgressBar(false);
        setLoading(false);
      });
  };

  // Modal for delete confirmation
  const openTrash = (ROWID) => {
    setDeleteSalesOrdersROWID(ROWID);
    setIsOpen(true);
  };
  const closeTrash = () => {
    setIsOpen(false);
    setDeleteSalesOrdersROWID("");
  };

  // Handle row selection
  const handleRowSelect = (ROWID) => {
    setSelectedRows((prevSelectedRows) => {
      const isSelected = prevSelectedRows.includes(ROWID);
      const updatedRows = isSelected ? prevSelectedRows.filter((id) => id !== ROWID) : [...prevSelectedRows, ROWID];
      setSelectedRows(prevSelectedRows);
      setSalesOrdersROWId(prevSelectedRows.join(","));
      console.log("Selected rows:", updatedRows);
      return updatedRows;
    });
  };

  // Handle "select all" functionality
  const handleSelectAllRows = () => {
    setSelectedRows((prevSelectedRows) => {
      const updatedRows = prevSelectedRows.length === salesOrdersData?.length ? [] : salesOrdersData.map((item) => item?.salesOrders?.ROWID);

      console.log("Selected rows:", updatedRows);
      return updatedRows;
    });
  };

  const openDrawer = () => {
    setIsDrawerOpen(true);
  };
  const closeDrawer = () => {
    setIsDrawerOpen(false);
  };

  // Functions to retrieve company name, employee name, and vendor name by ID
  const companyName = (id) => {
    if (id) {
      const temp = companyData.find((item) => item?.companies?.ROWID === id);
      return temp ? temp?.companies?.accountName || "N/A" : "N/A";
    } else {
      return "N/A";
    }
  };

  const employeesName = (id) => {
    if (id) {
      const temp = userList.find((item) => item?.employees?.ROWID === id);
      return temp ? temp?.employees?.employeeName || "N/A" : "N/A";
    } else {
      return "N/A";
    }
  };

  const vendorName = (id) => {
    console.log({ vendorData });
    console.log({ id });
    if (id) {
      const temp = vendorData?.find((item) => item?.vendor?.ROWID === id);
      console.log({ temp });
      return temp ? temp?.vendor?.vendorName || "N/A" : "N/A";
    } else {
      return "N/A";
    }
  };

  return (
    <>
      {loading && (
        <div className="spinner-overlay">
          <Spinner size="xl" color="pink.500" />
        </div>
      )}
      <Modal isOpen={isOpen} onClose={closeTrash}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Are you sure you want to Delete?</ModalHeader>
          <ModalCloseButton />
          <ModalBody></ModalBody>
          <ModalFooter>
            <Button className="create-button" mr={3} onClick={handleDelete}>
              Delete
            </Button>
            <Button className="cancel-button" onClick={closeTrash}>
              Cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <div>
        <div ref={desktopRef}>
          <div className="d-flex justify-content-between">
            {/* <button className="new-button mx-2" onClick={openDrawer}>
              <Plus size="18px" />
              <span className="ms-1">New</span>
            </button> */}
            <div className="w-50">
              {selectedRows.length > 0 && (
                <>
                  {filterData?.find((mod) => mod.moduleName === "Sales Order" && mod.delete === true) && (
                    <button className="new-button mx-2" onClick={openTrash}>
                      <Plus size="18px" />
                      <span className="ms-1">Delete All</span>
                    </button>
                  )}
                </>
              )}
            </div>
            <div className="d-flex justify-centent-start">
              {filterData?.find((mod) => mod.moduleName === "Sales Order" && mod.add === true) && (
                <button className="new-button mx-2" onClick={openDrawer}>
                  <Plus size="18px" />
                  <span className="ms-1">New</span>
                </button>
              )}
            </div>
          </div>
        </div>
        <div className="custom-scroll " style={{ minHeight: "75vh", overflow: "scroll" }}>
          <TableContainer
            className="card card-detail mt-1 scrollable-container"
            style={{ minHeight: "75vh", backgroundColor: "#EFEFEF", border: "none", position: "relative", overflowY: "scroll", scrollbarColor: "#A0AEC0 #EDF2F7", scrollbarWidth: "10px" }}
          >
            <Table variant="simple" size="sm">
              <Thead>
                <Tr className="tr-border">
                  <Th className="py-1 th-color">
                    <Checkbox isChecked={selectedRows.length === salesOrdersData?.length} onChange={handleSelectAllRows} />
                  </Th>
                  <Th className="py-1 th-color">Actions</Th>
                  <Th className="py-1 th-color">Customer Name</Th>
                  <Th className="py-1 th-color">Sales Order</Th>
                  <Th className="py-1 th-color">Reference</Th>
                  <Th className="py-1 th-color">Sales Order Date</Th>
                  <Th className="py-1 th-color">Expected Shipment Date</Th>
                  <Th className="py-1 th-color">Sales Person</Th>
                  <Th className="py-1 th-color">Franchisee Account</Th>
                  <Th className="py-1 th-color">Job Type</Th>
                </Tr>
              </Thead>
              <Tbody>
                {salesOrdersData &&
                  salesOrdersData?.map((item, index) => (
                    <Tr key={index} className="tr-border" style={{ position: "relative" }}>
                      <Td>
                        <Checkbox isChecked={selectedRows.includes(item?.salesOrders?.ROWID)} onChange={() => handleRowSelect(item?.salesOrders?.ROWID)} />
                      </Td>
                      {/* <Td>
                      <div className="d-flex gap-1">
                        <Link to="/salesorder-detail-view" state={{ ROWID: item?.salesOrders?.ROWID }}>
                          <i style={{ cursor: 'pointer' }}><Eye color="#ff176b" size="16px" strokeWidth="1" /></i>
                        </Link>
                        {filterData[10].moduleName === "Sales Order" && filterData[10].modifyAll === true ?

                          <i onClick={() => {
                            openDrawer(item.salesOrders);
                            setDataToEdit(item.salesOrders);
                            setIsUpdateMode(true);
                            setSalesOrdersId(item?.salesOrders?.ROWID)
                          }} style={{ cursor: 'pointer' }}><SquarePen color="#ff176b" size="16px" strokeWidth="1" /></i> : ""}
                        {filterData[10].moduleName === "Sales Order" && filterData[10].delete === true ?
                          <i onClick={(e) => {
                            openTrash(e);
                            setDeleteSalesOrdersROWID(item?.salesOrders?.ROWID);
                          }} style={{ cursor: 'pointer' }}><Trash2 color="#ff176b" size="16px" strokeWidth="1" onClick={openTrash} /></i> : ""}
                      </div>
                    </Td> */}
                      <Td style={{ width: "110px", textAlign: "center" }} onClick={(e) => e.stopPropagation()}>
                        <EllipsisMenu
                          item={item}
                          onView={() => navigate("/salesorder-detail-view", { state: { ROWID: item?.salesOrders?.ROWID } })}
                          onEdit={() => {
                            openDrawer(item.salesOrders);
                            setDataToEdit(item.salesOrders);
                            setIsUpdateMode(true);
                            setSalesOrdersId(item?.salesOrders?.ROWID);
                          }}
                          onDelete={() => {
                            openTrash();
                            setDeleteSalesOrdersROWID(item?.salesOrders?.ROWID);
                          }}
                          permissions={{
                            canEdit: filterData?.find((mod) => mod.moduleName === "Sales Order" && mod.modifyAll === true),
                            canDelete: filterData?.find((mod) => mod.moduleName === "Sales Order" && mod.delete === true),
                            canView: true, // Usually always true, but you can make this dynamic too
                          }}
                        />
                      </Td>
                      <Td className="font-colors">{companyName(item?.salesOrders?.customerName)}</Td> {/* Company name */}
                      <Td className="font-colors">{item?.salesOrders?.salesOrder}</Td>
                      <Td className="font-colors">{item?.salesOrders?.reference}</Td>
                      <Td className="font-colors">{item?.salesOrders?.salesOrderDate}</Td>
                      <Td className="font-colors">{item?.salesOrders?.expectedShipmentDate}</Td>
                      <Td className="font-colors">{employeesName(item?.salesOrders?.salesPerson)}</Td> {/* Employee name */}
                      <Td className="font-colors">{vendorName(item?.salesOrders?.franchiseeAccount)}</Td> {/* Vendor name */}
                      <Td className="font-colors">{item?.salesOrders?.jobType}</Td>
                    </Tr>
                  ))}
              </Tbody>
            </Table>
          </TableContainer>
        </div>
        <div className="footer">
          <div className="footer d-flex fixed-bottom start-20">
            <div className="total" style={{ marginLeft: "16%", marginTop: "15px" }}>
              <p class="fw-semibold">Total Count: {totalCount}</p>
            </div>

            <div className="d-flex align-items-center justify-content-center position-fixed-bottom mx-auto">
              <Pagination totalPages={Math.ceil(totalCount / 30)} onPageChange={setCurrentPage} />
            </div>
          </div>
        </div>
        {isDrawerOpen ? (
          <SalesForm
            closeDrawer={closeDrawer}
            isDrawerOpen={isDrawerOpen}
            isUpdateMode={isUpdateMode}
            onNewDataAdded={handleNewData}
            salesOrdersId={salesOrdersId}
            salesOrdersROWId={salesOrdersROWId}
            dataToEdit={dataToEdit}
            setIsUpdateMode={setIsUpdateMode}
          />
        ) : null}
      </div>
    </>
  );
}

export default SalesList;
